import {SectionIntro, Section, Box} from '@primer/react-brand'
import type {SupportSectionProps} from './types'
import {renderWithNoMarks} from '../../../utils'
import {SupportIconCards} from './SupportIconCards'
import {SupportImageCards} from './SupportImageCards'
import {SupportPillars} from './SupportPillars'
import {SupportStats} from './SupportStats'
import {SupportGrid} from './SupportGrid'

export const SupportSection = ({
  supportHeading,
  supportLabel,
  supportDescription,
  supportDetails,
  supportIconCards,
  supportPillars,
  supportImageCards,
  supportStats,
}: SupportSectionProps) => {
  const hasDetails = Boolean(
    (supportDetails === 'Icon Cards' && supportIconCards?.length) ||
    (supportDetails === 'Image Cards' && supportImageCards?.length) ||
    (supportDetails === 'Pillars' && supportPillars?.length) ||
    (supportDetails === 'Statistics' && supportStats?.length),
  )

  if (!supportHeading && !supportDescription && !supportLabel && !hasDetails) {
    return null
  }

  return (
    <Box>
      <Section paddingBlockStart="none" paddingBlockEnd="condensed">
        <SectionIntro align="center">
          {supportLabel && <SectionIntro.Label>{supportLabel}</SectionIntro.Label>}
          {supportHeading && <SectionIntro.Heading>{renderWithNoMarks(supportHeading)}</SectionIntro.Heading>}
          {supportDescription && (
            <SectionIntro.Description>{renderWithNoMarks(supportDescription)}</SectionIntro.Description>
          )}
        </SectionIntro>
      </Section>
      {hasDetails && (
        <Box
          data-testid="support-details-section"
          marginBlockEnd={64}
          borderBlockEndWidth="thin"
          borderBlockStartWidth="thin"
          borderStyle="solid"
          borderColor="muted"
        >
          <SupportGrid>
            {supportDetails === 'Icon Cards' && supportIconCards && <SupportIconCards items={supportIconCards} />}
            {supportDetails === 'Image Cards' && supportImageCards && <SupportImageCards items={supportImageCards} />}
            {supportDetails === 'Pillars' && supportPillars && <SupportPillars items={supportPillars} />}
            {supportDetails === 'Statistics' && supportStats && <SupportStats items={supportStats} />}
          </SupportGrid>
        </Box>
      )}
    </Box>
  )
}
